import { Icon } from '@chakra-ui/react';

const VIcon = ({ children, ...props }) => {
  return <Icon {...props}>{children}</Icon>;
};

export default VIcon;
